import { combineReducers } from "redux";
import ISSLocationReducer from "./ISSLocationReducer";


const rootReducer = combineReducers({
    ISSLocationReducer
})

export default rootReducer;